export const insuranceCompanyOptions = [
  { label: '平安保险', value: '1' },
  { label: '太平洋保险', value: '2' },
  { label: '中国人保', value: '3' },
];
